<div class="super-admin-padding">
  <div class="super-admin-page theme-background-color">
    <div class="super-admin-header">Super admin</div>
    <h1>Scripts</h1>

    <div class="admin-btn">
      <button
        mat-raised-button
        color="primary"
        (click)="googleTagRegistration()"
      >
        Trigger Google Tag registration event
      </button>
    </div>

    <div class="admin-btn">
      <button mat-raised-button color="primary" (click)="googleTagPurchase()">
        Trigger Google Tag purchase event
      </button>
    </div>

    <div class="admin-btn">
      <button mat-raised-button color="primary" (click)="superAdmin404()">
        SuperAdmin404
      </button>
    </div>
  </div>
</div>
